import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconDataManagerS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4C16 5.65685 14.6569 7 13 7C11.3431 7 10 5.65685 10 4H8.5C8.22386 4 8 4.22386 8 4.5V11.5C8 11.7761 8.22386 12 8.5 12H10C10 10.3431 11.3431 9 13 9C14.6569 9 16 10.3431 16 12C16 13.6569 14.6569 15 13 15C11.6938 15 10.5825 14.1652 10.1707 13H8.5C7.67157 13 7 12.3284 7 11.5V8.5H5.95852C5.72048 9.91886 4.4865 11 3 11C1.34315 11 0 9.65685 0 8C0 6.34315 1.34315 5 3 5C4.4865 5 5.72048 6.08114 5.95852 7.5H7V4.5C7 3.67157 7.67157 3 8.5 3H10.1707C10.5825 1.83481 11.6938 1 13 1C14.6569 1 16 2.34315 16 4ZM15 4C15 5.10457 14.1046 6 13 6C11.8954 6 11 5.10457 11 4C11 2.89543 11.8954 2 13 2C14.1046 2 15 2.89543 15 4ZM3 6C4.10457 6 5 6.89543 5 8C5 9.10457 4.10457 10 3 10C1.89543 10 1 9.10457 1 8C1 6.89543 1.89543 6 3 6ZM15 12C15 13.1046 14.1046 14 13 14C11.8954 14 11 13.1046 11 12C11 10.8954 11.8954 10 13 10C14.1046 10 15 10.8954 15 12Z"
      />
    </svg>
  )
}

export const IconDataManager = createIcon({
  l: IconDataManagerS,
  m: IconDataManagerS,
  s: IconDataManagerS,
  xs: IconDataManagerS,
  name: 'IconDataManager',
})
